<template>

  <!-- This file holds the components for input validation. 
       For example, this will consist of numbers, charcters, and strings.-->

  <div class="validated-input">
    <input
      :type="type"
      :value="modelValue"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      :maxlength="maxLength"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{invalid: errorMessage}"
    />
  </div> 
</template>

<script>
export default {
  name: "ValidInput",  
  props: {
    modelValue: { type: String, default: "" },
  type: { type: String, default: "text" },
  maxLength: { type: Number, default: null },
  placeholder: { type: String, default: "" },
  rules: { type: Array, default: () => [] }, 
  disabled: {type: Boolean, default: false }, 

  },
  data() {
    return {
      errorMessage: ""
    };
  },
  methods: {

    //Method to initiate the input methods
    onInput(event){
      let value = event.target.value;
      this.errorMessage = "";
      this.$emit("update:modelValue", value);
      //this.$emit("input", value);
    },
    onBlur(event){
      let value = event.target.value.trim();
      if (value.startsWith("$")){
        value = value.slice(1);
      }
      if (this.validate(value) && value){
        const nullCheck = parseFloat(value);
        if(!isNaN(nullCheck)){
          value = parseFloat(value).toFixed(2);
        }
        
      }
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
    onFocus(event){
      this.errorMessage = "";
    },
    validate(value){
      this.errorMessage = "";

      for (const rule of this.rules){
        let result; 
        switch (rule){
          case "stringOnly":
            result = this.validateStringInput(value);
            break; 

          case "numberOnly":
            result = this.validateNumberInput(value);
            break;
          
          case "noNull":
            result = this.validateNoNullInput(value);
            break;
          
          case "floatOnly":
            result = this.validateFloatInput(value);
            break;
          
          case "taxInput":
            result = this.validateTaxInput(value);
            break;

          default:
            result = true;

        }

        if (result !== true){
          this.errorMessage = result;
          return false;
        }

      }
      return true;
    },

    //REGULAR EXPRESSIONS BELOW THIS LINE

    //Method to validate the input is a string
    validateStringInput(value) {
      return /^[a-zA-Z\s]*$/.test(value) ?  true : "invalid";

    }, 
    //Method to validate if the input is a number
    validateNumberInput(value){
      return /^[0-9]*$/.test(value) ?  true : "invalid";
    }, 
    //Method to validate the input is not Null
    validateNoNullInput(value){
      return value.trim().length > 0 ?  true : "invalid";
    }, 
    //Method to valdiate that the input is a float
    validateFloatInput(value){
      return /^\d+(\.\d{0,2})?$/.test(value) ?  true : "invalid";
    }, 
    //Method to validate the input is valid for tax percents
    validateTaxInput(value){
      return /^-?\d*(\.\d{1,2})?$/.test(value) ?  true : "invalid";
    }
    
    //REGULAR EXPRESSIONS ABOVE THIS LINE

  },
};
</script>

<style scoped>
input.invalid {
  border: 2px solid red;
  box-shadow: 0 0 5px red;
}
input{
  padding: 0.5em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

</style>
